/**
 * Global Splide loader – load the library once, then run any init.
 * Use this so home-hero, widgets, and [splide-init] don't each inject the script.
 * Does not init any sliders; components still do their own init with their own configs.
 */
(function () {
	var SPLIDE_CDN_URL = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
	var SPLIDE_CSS_URL = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';

	if (typeof window.SPLIDE_CDN_URL === 'undefined') {
		window.SPLIDE_CDN_URL = SPLIDE_CDN_URL;
	}

	var loaded = false;
	var loading = null;
	var queue = [];

	function ensureSplideCSS() {
		if (document.querySelector('link[href*="splide.min.css"]')) return;
		var link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = SPLIDE_CSS_URL;
		document.head.appendChild(link);
	}

	function runQueue() {
		queue.forEach(function (cb) {
			try {
				cb();
			} catch (e) {
				console.error('splideWhenReady callback error:', e);
			}
		});
		queue = [];
	}

	function doLoad(callback) {
		ensureSplideCSS();
		var script = document.createElement('script');
		script.src = window.SPLIDE_CDN_URL;
		script.onload = function () {
			loaded = true;
			loading = null;
			runQueue();
			if (callback) callback();
		};
		script.onerror = function () {
			loading = null;
			queue = [];
			if (callback) callback();
		};
		document.head.appendChild(script);
	}

	/**
	 * Run callback when Splide is available. Loads the script once if needed.
	 * @param {function} callback - Called with no args when window.Splide is defined.
	 */
	window.splideWhenReady = function (callback) {
		if (typeof callback !== 'function') return;
		if (typeof window.Splide !== 'undefined') {
			callback();
			return;
		}
		queue.push(callback);
		if (loading) return;
		var existing = document.querySelector('script[src="' + window.SPLIDE_CDN_URL + '"]');
		if (existing) {
			loading = true;
			existing.addEventListener('load', function () {
				loaded = true;
				loading = null;
				runQueue();
			});
			return;
		}
		loading = true;
		doLoad();
	};
})();
